<template lang="pug">
  .products
    .background-header.white
      v-container.white(style="max-width:600px")
        h6.ml-2.my-6 Sync Products
        v-text-field.ma-2.p1(v-model="searchText"
                             solo flat hide-details dense outlined
                             background-color="basic200"
                             placeholder='Search product'
                             height="40")
          template(v-slot:append)
            eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600") Search Products
    v-container(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout(v-else)
        WCProductSync.mt-2.mb-8(:ecommerce="ecommerce")
        v-layout.my-6(v-if="products.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.c1.basic500 Products not found or empty
        .items-layout(v-else)
          .list-item.my-2(three-line)
            template(v-for='product in currentProducts')
              woocommerce-product-item(:product="product" :key="product.id")
      div.mt-4
        y-pagination.ma-4(v-model="page" :pageSize="pageSize" :count="count")
</template>

<script>
import WoocommerceProductItem from '@/components/WoocommerceProductItem'
import WCProductSync from '@/components/ecommerce/woocommerce/WoocommerceProductSync.vue'

import { mapActions } from 'vuex'
import queryString from 'query-string'
export default {
  name: 'SyncWoocommerceProducts',
  components: { WoocommerceProductItem, WCProductSync },
  props: ['ecommerce'],
  data: () => ({
    isFetching: false,
    isTyping: false,
    pageSize: 10,
    page: 1,
    count: 0,
    products: [],
    searchText: '',
    isLoading: false,
    searchCountDown: null
  }),
  mounted () {
    if (!this.$route.query.page) {
      this.fetchProducts(1)
    } else {
      this.fetchProducts(this.$route.query.page)
    }
  },
  computed: {
    currentProducts () {
      return this.products
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/ecommerce/woocommerce/products/?page=${page}&page_size=${this.pageSize}&settings=${this.ecommerce.id}&ordering=-id`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.products = response.data.results
        this.count = response.data.count
      })
      .catch(() => {})
      .finally(() => {
        this.isFetching = false
      })
    },
    clickAddProduct () {
      this.showAddProductDialog = true
    },
    searchItem () {
      let searchUrl = `/ecommerce/woocommerce/products/?page=1&page_size=${this.pageSize}&settings=${this.ecommerce.id}&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.products = response.data.results
          this.count = response.data.count
        }).catch(() => {})
    },
  }
}
</script>

<style scoped>
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.clickable {
  cursor: pointer;
}
</style>

<i18n>
{
  "en": {
    "weight": {
      "label": "Weight",
      "placeholder": "Min = 0.1 kg | Max = 60 kg",
      "hint": "Set this weight to all products in this page"
    }
  },
  "id": {
    "weight": {
      "label": "Berat",
      "placeholder": "Min = 0.1 kg | Maks = 60 kg",
      "hint": "Terapkan berat ini untuk semua produk di halaman ini"
    }
  }
}
</i18n>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>